// @flow

import { completeRequest, beginRequest } from "@store/utils";
import type { DefaultStandardScriptsState } from "./types";

const startRequest = beginRequest(["requestsInProgress"]);

const finishRequest = completeRequest(["requestsInProgress"]);

export const onGetDefaultStandardScripts = (state: DefaultStandardScriptsState) => () =>
  startRequest(state);

export const onGetDefaultStandardScriptsSuccess = (state: DefaultStandardScriptsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  list: payload,
});

export const onGetDefaultStandardScriptsError = (state: DefaultStandardScriptsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

export const onGetDefaultStandardScriptSuccess = (state: DefaultStandardScriptsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  current: payload,
});

export const onGetDefaultStandardScriptError = (state: DefaultStandardScriptsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

export const onUpdateDefaultStandardScriptError = (state: DefaultStandardScriptsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

export const onUpdateDefaultStandardScriptDraft = (state: DefaultStandardScriptsState) => ({
  payload,
}: Object) => ({
  ...state,
  draft: payload,
});

export const onToggleEditDefaultStandardScriptModal = (state: DefaultStandardScriptsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showEditModal: payload,
  },
});
